import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type StoreService from 'scaleflow/services/store';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
import type RouterService from '@ember/routing/router-service';
import type ScansNewController from 'scaleflow/controllers/scans/new';
import connectors from 'scaleflow/utils/connectors-config';

export default class ScansNewRoute extends Route {
  @service declare store: StoreService;
  @service declare betaToggle: BetaToggleService;
  @service declare router: RouterService;

  beforeModel() {
    if (!this.betaToggle.isPlatformAdmin) this.router.transitionTo('scans');
  }

  async model() {
    const scan = this.store.createRecord('scan', {});
    const integrations = await this.store.findAll('integration-setting', {
      reload: true,
    });
    return { scan, connectors, integrations };
  }

  resetController(controller: ScansNewController, isExiting: boolean) {
    if (isExiting) {
      controller.currentStep = 1;
      controller.connectorType = null;
      controller.selectedRepos = new Set();
      controller.isStarting = false;
      controller.githubRepos = [];
      controller.isFetchingGithubRepos = false;
      controller.repoSearch = '';
      controller.orgName = '';
      controller.publicRepos = [];
      controller.isFetchingPublicRepos = false;
      controller.publicFetchError = null;
      controller.hasFetched = false;
      const scan = controller.model?.scan;
      if (scan?.isNew) scan.deleteRecord();
    }
  }
}
